// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 4: CRUCIFIXIÓN Y RESURRECCIÓN
// ============================================================================
// Niveles 40-52 (13 niveles, 39 preguntas)

export const chapter4Translations = {
  name: "Crucifixión y Resurrección",
  description: "¡Ha resucitado!",
  
  spiritualWisdom: {
    principle: "Por su muerte y resurrección, Jesús nos da la vida eterna",
    scripture: "Yo soy la resurrección y la vida. El que cree en mí, aunque muera, vivirá (Juan 11:25)",
    application: "La cruz y la tumba vacía son el corazón de nuestra fe y la fuente de nuestra esperanza"
  },
  
  levels: {
    40: {
      name: "El Arresto",
      challenge: "Judas, ¿con un beso entregas al Hijo del Hombre?",
      easy: {
        question: "¿Quién traicionó a Jesús?",
        options: ["Pedro", "Judas", "Tomás", "Mateo"],
        hint: "Uno de los doce discípulos",
        funFact: "💔 ¡Judas vendió a Jesús por 30 piezas de plata - el precio de un esclavo!"
      },
      medium: {
        question: "¿Qué señal usó Judas para identificar a Jesús?",
        options: [
          "Lo señaló con el dedo",
          "Lo llamó por su nombre",
          "Le dio un beso",
          "Lo señaló a los soldados"
        ],
        hint: "Un gesto de afecto pervertido",
        funFact: "😢 ¡El beso, símbolo de amor, se convierte en instrumento de traición!"
      },
      hard: {
        question: "¿Cómo reaccionó Jesús ante la traición y el arresto?",
        options: [
          "Se defendió violentamente",
          "Huyó",
          "Aceptó con dignidad y sanó la oreja del siervo",
          "Maldijo a sus enemigos"
        ],
        hint: "Mostró amor incluso hacia sus enemigos",
        funFact: "✨ ¡Incluso al ser arrestado, Jesús sanó la oreja cortada de Malco!"
      }
    },
    
    41: {
      name: "La Negación de Pedro",
      challenge: "Antes que cante el gallo, me negarás tres veces...",
      easy: {
        question: "¿Cuántas veces negó Pedro a Jesús?",
        options: ["1 vez", "2 veces", "3 veces", "4 veces"],
        hint: "El número que Jesús había predicho",
        funFact: "🐓 ¡El canto del gallo recordó a Pedro la profecía de Jesús!"
      },
      medium: {
        question: "¿Dónde estaba Pedro cuando negó a Jesús?",
        options: [
          "En el Templo",
          "Ante Pilato",
          "En el patio del sumo sacerdote",
          "En el camino"
        ],
        hint: "Seguía a Jesús de lejos",
        funFact: "🔥 ¡Pedro se calentaba junto al fuego con los enemigos de Jesús!"
      },
      hard: {
        question: "¿Qué nos enseña la restauración de Pedro después de su negación?",
        options: [
          "Algunos pecados son imperdonables",
          "El amor de Jesús levanta incluso nuestras mayores caídas",
          "Pedro era indigno",
          "Hay que ocultar nuestras faltas"
        ],
        hint: "Se trata de la gracia que restaura",
        funFact: "💝 ¡Jesús pregunta 3 veces '¿Me amas?' para restaurar las 3 negaciones!"
      }
    },

    42: {
      name: "Jesús ante Pilato",
      challenge: "¿Eres tú el Rey de los judíos? Tú lo dices...",
      easy: {
        question: "¿Quién era el gobernador romano que juzgó a Jesús?",
        options: ["César", "Pilato", "Herodes", "Antonio"],
        hint: "El representante de Roma en Judea",
        funFact: "⚖️ ¡Pilato reconoce la inocencia de Jesús pero lo condena por cobardía!"
      },
      medium: {
        question: "¿Qué costumbre propuso Pilato usar?",
        options: [
          "Liberar a un prisionero en la Pascua",
          "Posponer el juicio",
          "Apelar a César",
          "Exiliar a Jesús"
        ],
        hint: "Una tradición pascual",
        funFact: "🔓 ¡Pilato esperaba liberar a Jesús gracias a esta costumbre pascual!"
      },
      hard: {
        question: "¿Qué revela la actitud de Pilato sobre la justicia humana?",
        options: [
          "La justicia siempre se hace",
          "La presión popular puede corromper incluso la justicia",
          "Pilato era malvado",
          "La política prima sobre la verdad"
        ],
        hint: "Se trata de la debilidad ante la multitud",
        funFact: "💧 ¡Pilato se lava las manos pero sigue siendo responsable de la injusticia!"
      }
    }
  }
};

export default chapter4Translations;
